import React, { Component } from "react";
import Loader from '../../components/Loader/Loader';
import * as cms from '../../shared/repos/cms/cms';
import cmsKeys from '../../shared/constants/cms';

import styles from './AllergenAndNutritionInfo.module.css'
import CmsInlineEdit from "../../components/Cms/CmsInlineEdit";
import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';
import SecondaryPageEmpty from '../SecondaryPages/SecondaryPageEmpty';

class AllergenAndNutritionInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            content: [],
            loading: true
        };
    }

    componentDidMount() {
        cms.getContent([cmsKeys.allergenAndNutritionInfoPage.allergenStatementSections], this);
    }

    render() {
        const { content, loading } = this.state;
        if (!content.length) {
            return (
              <div className={styles.pageWrapper} data-region="secondary-page" data-page="AllergenAndNutritionInfo">
                <div className={styles.pageContainer} data-part="content-surface">
                  {isBrandRefreshEnabled() && !loading ? <SecondaryPageEmpty /> : <Loader id="loader" />}
                </div>
              </div>
            );
        }

        return (
          <div className={styles.pageWrapper} data-region="secondary-page" data-page="AllergenAndNutritionInfo">
            <div className={`${styles.pageContainer} text-dark dark:text-white`} data-part="content-surface">
              {content.map(allergen => {
                    return (
                      <div>
                        <div className={styles.pageSection} data-part="prose-section">
                          <h1><CmsInlineEdit cmsNode={allergen}>{allergen.value}</CmsInlineEdit></h1>
                        </div>

                        {allergen.children.map(allergenStatement => {
                                return (
                                  <div className={styles.pageSection} data-part="prose-section">
                                    <p><CmsInlineEdit cmsNode={allergenStatement}>{allergenStatement.value}</CmsInlineEdit></p>
                                  </div>
                                )
                            })}
                      </div>
                    )
                })}
            </div>
          </div>
        );
    }
}

export default AllergenAndNutritionInfo;
